import { clsx, type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleString('zh-CN');
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'pending': return 'text-amber-700 bg-amber-50 border-amber-200';
    case 'replied': return 'text-emerald-700 bg-emerald-50 border-emerald-200';
    case 'processing': return 'text-blue-700 bg-blue-50 border-blue-200';
    case 'closed': return 'text-gray-700 bg-gray-50 border-gray-200';
    default: return 'text-gray-700 bg-gray-50 border-gray-200';
  }
}

export function getStatusText(status: string): string {
  switch (status) {
    case 'pending': return '待处理';
    case 'replied': return '已回复';
    case 'processing': return '处理中';
    case 'closed': return '已关闭';
    default: return status;
  }
}

export function getRuleTypeText(type: string): string {
  switch (type) {
    case 'user': return '用户';
    case 'non_user': return '非用户';
    case 'auto_reply': return '自动回复';
    case 'hide': return '隐藏邮件';
    default: return type;
  }
}

export function getRuleTypeColor(type: string): string {
  switch (type) {
    case 'user': return 'text-emerald-700 bg-emerald-50 border-emerald-200';
    case 'non_user': return 'text-red-700 bg-red-50 border-red-200';
    case 'auto_reply': return 'text-blue-700 bg-blue-50 border-blue-200';
    case 'hide': return 'text-gray-700 bg-gray-50 border-gray-200';
    default: return 'text-gray-700 bg-gray-50 border-gray-200';
  }
} 